
import { ICommonIconProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * It renders a package return customer icon.
 */
export function PackageReturnCustomerIcon({ className }: Readonly<ICommonIconProps>) {
  return (
    <svg className={className} fill="none" viewBox="0 0 24 24">
      <path
        d="M12 14.975V13.975C12.0147 13.1749 11.7033 12.4033 11.1375 11.8375C10.5717 11.2717 9.80005 10.9603 8.99999 10.975H5.99999C5.19993 10.9603 4.42831 11.2717 3.86249 11.8375C3.29667 12.4033 2.98532 13.1749 2.99999 13.975V14.975"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 5H19C20.1046 5 21 5.89543 21 7V12C21 13.1046 20.1046 14 19 14H15"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="7.45801"
        cy="5.5"
        r="2.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 8H15"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.59192 17H6"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 17V19.5561"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.38113 17C6.98664 18.1302 7.90547 19.0615 9.0273 19.6823C10.5699 20.5311 12.3886 20.725 14.0755 20.2208C15.7624 19.7165 17.1763 18.5561 18 17"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
